import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import SignersTable from "./signersTable"

const Signers = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Signatory"} />
          <SignersTable />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Signers
